import React, { useState } from "react";
import { ArrowLeftRight, Train, Plane, Bus, Plus, Minus, LayoutGrid } from 'lucide-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SearchFormSection = ({
    fromLocation,
    setFromLocation,
    toLocation,
    setToLocation,
    travelDate,
    setTravelDate,
    passengerCounts,
    setPassengerCounts,
    seatClass,
    setSeatClass,
    activeMode,
    setActiveMode,
    nonStopOnly,
    setNonStopOnly,
    handleSearch
}) => {
    const [showTravelersModal, setShowTravelersModal] = useState(false);

    const isFormValid = fromLocation && toLocation && travelDate;

    return (
        <section className="home-search-section">
            <div style={{ position: 'relative' }}>
                <div className="home-search-bar">
                    <div className="search-field" style={{ flex: '1.2' }}>
                        <input
                            type="text"
                            className="search-field-input"
                            placeholder="From"
                            value={fromLocation}
                            onChange={(e) => setFromLocation(e.target.value)}
                        />
                        <div className="swap-btn" onClick={() => {
                            const temp = fromLocation;
                            setFromLocation(toLocation);
                            setToLocation(temp);
                        }}>
                            <ArrowLeftRight size={20} />
                        </div>
                        <input
                            type="text"
                            className="search-field-input"
                            placeholder="To"
                            value={toLocation}
                            onChange={(e) => setToLocation(e.target.value)}
                        />
                    </div>

                    <div className="search-field-sep"></div>

                    <div className="search-field date-picker-container">
                        <DatePicker
                            selected={travelDate}
                            onChange={(date) => setTravelDate(date)}
                            dateFormat="MMM dd/eee"
                            className="search-field-input"
                            placeholderText="Select date"
                            minDate={new Date()}
                            isClearable={false}
                        />
                    </div>

                    <div className="search-field-sep"></div>

                    <div className="search-field" onClick={() => setShowTravelersModal(!showTravelersModal)} style={{ cursor: 'pointer' }}>
                        <div className={`search-field-input ${!travelDate || !fromLocation || !toLocation ? 'placeholder' : ''}`}>
                            {(passengerCounts.Adults > 0 && travelDate && fromLocation && toLocation) ? `${passengerCounts.Adults} adult, ${seatClass}` : "Travelers & Seat classes"}
                        </div>

                        {showTravelersModal && (
                            <div className="travelers-dropdown" onClick={(e) => e.stopPropagation()}>
                                <h2 className="modal-title">Travelers</h2>
                                {Object.entries(passengerCounts).map(([type, count]) => (
                                    <div className="traveler-type-row" key={type}>
                                        <div className="type-info">
                                            <div className="label-with-age">
                                                <h4>{type}</h4>
                                                <span>{type === 'Adults' ? '18+' : type === 'Students' ? 'over 18' : type === 'Youths' ? '12-17' : type === 'Children' ? '2-11' : type === 'Infants on lap' ? 'under 2' : ''}</span>
                                            </div>
                                        </div>
                                        <div className="counter-btns">
                                            <button
                                                className="count-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setPassengerCounts(prev => ({ ...prev, [type]: Math.max(0, prev[type] - 1) }));
                                                }}
                                            >
                                                <Minus size={14} />
                                            </button>
                                            <span>{count}</span>
                                            <button
                                                className="count-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setPassengerCounts(prev => ({ ...prev, [type]: prev[type] + 1 }));
                                                }}
                                            >
                                                <Plus size={14} />
                                            </button>
                                        </div>
                                    </div>
                                ))}

                                <div className="seat-classes-section">
                                    <h2 className="modal-title" style={{ fontSize: '20px', marginTop: '20px' }}>Train Seat Classes</h2>
                                    <div className="seat-classes-grid">
                                        {['Economy', 'Premium Economy', 'Business', 'First'].map(cls => (
                                            <div
                                                key={cls}
                                                className={`class-tag ${seatClass === cls ? 'active' : ''}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSeatClass(cls);
                                                }}
                                            >
                                                {cls}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="modal-actions">
                                    <button className="clear-btn" onClick={(e) => {
                                        e.stopPropagation();
                                        setPassengerCounts({ Adults: 1, Students: 0, Youths: 0, Children: 0, "Toddlers in own seat": 0, "Infants on lap": 0 });
                                        setSeatClass('Economy');
                                    }}>Clear</button>
                                    <button className="apply-btn" onClick={(e) => {
                                        e.stopPropagation();
                                        setShowTravelersModal(false);
                                    }}>Apply</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modes-container">
                    <span>Preferred modes</span>
                    <div className="modes-tabs">
                        <button className={`mode-btn ${activeMode === 'All' ? 'active' : ''}`} onClick={() => setActiveMode('All')}>
                            <LayoutGrid size={20} /> All
                        </button>
                        <button className={`mode-btn ${activeMode === 'Train' ? 'active' : ''}`} onClick={() => setActiveMode('Train')}>
                            <Train size={20} /> Train
                        </button>
                        <button className={`mode-btn ${activeMode === 'Flight' ? 'active' : ''}`} onClick={() => setActiveMode('Flight')}>
                            <Plane size={20} /> Flight
                        </button>
                        <button className={`mode-btn ${activeMode === 'Bus' ? 'active' : ''}`} onClick={() => setActiveMode('Bus')}>
                            <Bus size={20} /> Bus
                        </button>
                    </div>

                    <div className="options-row">
                        <label className="non-stop">
                            <input
                                type="checkbox"
                                checked={nonStopOnly}
                                onChange={(e) => setNonStopOnly(e.target.checked)}
                            />
                            <span>Non stop only</span>
                        </label>
                    </div>
                    <button
                        className="primary-search-btn"
                        disabled={!isFormValid}
                        onClick={handleSearch}
                    >
                        Search Routes
                    </button>
                </div>
            </div>
        </section>
    );
};

export default SearchFormSection;
